<div class="content"
     id="registerPage"
     [ngClass]="{'callReg-Normal' : DisplayMode == 1, 'callGlitch-Compact': DisplayMode == 2, 'callReg-Expanded': DisplayMode == 3}"
     [scrollTop]="DisplayMode == 3 ? 0 : 'auto'">
    <div class="row flex-nowrap">
        <div class="col-auto registerViewType pointer flex-fill align-items-center"
             [ngClass]="(DisplayMode == 2 ? 'd-flex' : '')"
             [hidden]="DisplayMode != 2"
             (click)="ShowQuickJob = !ShowQuickJob">
            <i class="ksv-icon-bolt fa-lg"></i>
        </div>

        <div class="col-auto"
             [hidden]="DisplayMode == 2 && ShowQuickJob == false">
            <div class="standardForm callRegister">
                <form class="" (ngSubmit)="FormSubmit()" name="frm">
                    <div [hidden]="DisplayMode == 2">
                        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
                    </div>

                    <div class="row">
                        <div class="col"
                             [ngClass]="DisplayMode == 2 ? 'd-flex flex-row': ''">
                            <div class="row"
                                 [ngClass]="DisplayMode == 2 ? 'entryCell': ''">
                                <div class="col"
                                     [ngClass]="DisplayMode == 2 ? 'd-flex flex-row regContainer': ''">
                                    <div class="row form-group align-items-center entryCell entryCell-Prop"
                                         *ngIf="masterService.LoggedInUserData.Properties.length > 1">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-property frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <select class="custom-select"
                                                    id="PropertyId"
                                                    [disabled]="Model.Operation == _GlitchOperationActions.Edit || SaveModel.length > 0"
                                                    [(ngModel)]="Model.PropertyId"
                                                    name="PropertyId"
                                                    (change)="onPropertyChange()">
                                                <option *ngFor="let row of lstProperties"
                                                        [value]="row.PropertyId">
                                                    {{row.PropertyName}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-Prop"
                                         [hidden]="DisplayMode == 2">
                                        <div class="col-1 entryIcon">
                                            &nbsp;
                                        </div>
                                        <div class="col">
                                            <div class="form-check form-check-inline">
                                                <input type="radio"
                                                       class="form-check-input"
                                                       name="PreArrival_Guest"
                                                       (ngModelChange)="onRegistrationTypeChange($event)"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       id="PreArrival_Guest"
                                                       [value]="_Glitch_RegistrationTypes.PreArrival_Guest"
                                                       [ngModel]="Model.GlitchRegistrationType" />
                                                <label class="form-check-label"
                                                       for="PreArrival_Guest"
                                                       translate>LBL.GLITCH_PREARRIVAL</label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input type="radio"
                                                       class="form-check-input"
                                                       name="In_House_Guest"
                                                       (ngModelChange)="onRegistrationTypeChange($event)"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       id="In_House_Guest"
                                                       [value]="_Glitch_RegistrationTypes.In_House_Guest"
                                                       [ngModel]="Model.GlitchRegistrationType" />
                                                <label class="form-check-label"
                                                       for="In_House_Guest"
                                                       translate>LBL.GLITCH_INHOUSE</label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input type="radio"
                                                       class="form-check-input"
                                                       name="CheckedOut_Guest"
                                                       (ngModelChange)="onRegistrationTypeChange($event)"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       id="CheckedOut_Guest"
                                                       [value]="_Glitch_RegistrationTypes.CheckedOut_Guest"
                                                       [ngModel]="Model.GlitchRegistrationType" />
                                                <label class="form-check-label"
                                                       for="CheckedOut_Guest"
                                                       translate>LBL.GLITCH_CHECKEDOUT</label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input type="radio"
                                                       class="form-check-input"
                                                       name="Visitor_Guest"
                                                       (ngModelChange)="onRegistrationTypeChange($event)"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       id="Visitor_Guest"
                                                       [value]="_Glitch_RegistrationTypes.Visitor_Guest"
                                                       [ngModel]="Model.GlitchRegistrationType" />
                                                <label class="form-check-label"
                                                       for="Visitor_Guest"
                                                       translate>LBL.GLITCH_VISITOR</label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input type="radio"
                                                       class="form-check-input"
                                                       name="Staff"
                                                       (ngModelChange)="onRegistrationTypeChange($event)"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       id="Staff"
                                                       [value]="_Glitch_RegistrationTypes.Staff"
                                                       [(ngModel)]="Model.GlitchRegistrationType" />
                                                <label class="form-check-label"
                                                       for="Staff"
                                                       translate>LBL.GLITCH_STAFF</label>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2 || Model.GlitchRegistrationType != _Glitch_RegistrationTypes.Visitor_Guest">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_guest frmIcon"></i>
                                        </div>
                                        <div class="col-10 entryFld">
                                            <div class="boxFrame">
                                                <div class="form-group form-row">
                                                    <div class="col-2">
                                                        <input type="text"
                                                               class="form-control"
                                                               [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                               name="Title"
                                                               [(ngModel)]="Model.Title"
                                                               placeholder="{{'PH.PH_TITLE' | translate}}"
                                                               maxlength="100" />
                                                    </div>
                                                    <div class="col-5">
                                                        <input type="text"
                                                               class="form-control"
                                                               [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                               name="FName"
                                                               [(ngModel)]="Model.FName"
                                                               placeholder="{{'PH.PH_FIRST_NAME' | translate}}*"
                                                               maxlength="100" />
                                                    </div>
                                                    <div class="col-5">
                                                        <input type="text"
                                                               class="form-control"
                                                               [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                               name="LName"
                                                               [(ngModel)]="Model.LName"
                                                               placeholder="{{'PH.PH_LAST_NAME' | translate}}*"
                                                               maxlength="100" />
                                                    </div>
                                                </div>
                                                <div class="form-group form-row">
                                                    <div class="col-6">
                                                        <input type="text"
                                                               class="form-control"
                                                               name="Email"
                                                               [(ngModel)]="Model.Email"
                                                               placeholder="{{'PH.PH_EMAIL' | translate}}" />
                                                    </div>
                                                    <div class="col-3">
                                                        <input type="text"
                                                               class="form-control"
                                                               name="MobileNumber"
                                                               [(ngModel)]="Model.MobileNumber"
                                                               placeholder="{{'PH.PH_MOBILE' | translate}}" />
                                                    </div>
                                                    <div class="col-3">
                                                        <input type="text"
                                                               class="form-control"
                                                               name="HomeNumber"
                                                               [(ngModel)]="Model.HomeNumber"
                                                               placeholder="{{'PH.PH_HOMENUMBER' | translate}}" />
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col">
                                                        <input type="text"
                                                               class="form-control"
                                                               name="Address"
                                                               [(ngModel)]="Model.Address"
                                                               placeholder="{{'PH.PH_ADDRESS' | translate}}"
                                                               maxlength="100" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="entryFld" [hidden]="Model.Operation == _GlitchOperationActions.Edit || !_appSettings.ShowGlitchVisitorSearch"
                                        *ngIf="(Model.FName && Model.FName.length >= VisitorSearchCharLimit.FName ) || (Model.LName && Model.LName.length >= VisitorSearchCharLimit.LName) || (Model.Email && Model.Email.length >= VisitorSearchCharLimit.Email) ||  (Model.MobileNumber && Model.MobileNumber.length >= VisitorSearchCharLimit.MobileNumber)">
                                                 <button type="button"
                                                  (click)="visitorSearchPopup.Open(Model)"
                                                class="btn btn-primary flex-fill">
                                            <img src="/assets/Search.svg" width="20px" height="20px" alt="Search_Icon">
                                        </button>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2 || Model.GlitchRegistrationType != _Glitch_RegistrationTypes.CheckedOut_Guest || Model.Operation == _GlitchOperationActions.Edit">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_guest frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <div class="d-flex align-items-center">
                                                <div class="mr-2"
                                                     *ngIf="Model.FullName">
                                                    {{Model.FullName}}
                                                </div>
                                                <div>
                                                    <a href="javascript:{}"
                                                       [hidden]="Model.Operation == _GlitchOperationActions.Edit"
                                                       (click)="guestSearchPopup.Open(Model.PropertyId)"
                                                       translate>BTN.BTN_SELECT_GUEST</a>
                                                </div>
                                                <!-- DEV-20345: split-screen Guest Details dialog trigger,
                                                     inline beside Select guest. Hidden on desktop via CSS. -->
                                                <div class="locationHistoryTrigger ml-3"
                                                     *ngIf="SelectedGuests.length && Model.GlitchRegistrationType != _Glitch_RegistrationTypes.Visitor_Guest">
                                                    <button type="button"
                                                            class="btn btn-outline-primary btn-sm"
                                                            (click)="openGuestDialog()">
                                                        <span translate>LBL.GUEST_DETAILS</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2 || !SelectedGuests.length || Model.Operation == _GlitchOperationActions.Register || (Model.Operation == _GlitchOperationActions.Edit && Model.GlitchRegistrationType == _Glitch_RegistrationTypes.Visitor_Guest)">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_guest frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <div class="d-flex">
                                                <div class="mr-2"
                                                     *ngIf="Model.FullName">
                                                    {{Model.FullName}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-Guest"
                                         [hidden]="Model.Operation == _GlitchOperationActions.Edit || Model.GlitchRegistrationType == _Glitch_RegistrationTypes.Staff || Model.GlitchRegistrationType == _Glitch_RegistrationTypes.Visitor_Guest  || Model.GlitchRegistrationType == _Glitch_RegistrationTypes.CheckedOut_Guest">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_guest frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstGuest"
                                                       class="req_place"
                                                       (change)="onGuestChange($event)"
                                                       bindLabel="FullName"
                                                       [multiple]="true"
                                                       placeholder="{{'PH.PH_GUEST' | translate}}"
                                                       name="GlitchGuestId"
                                                       appendTo="body"
                                                       [dropdownPosition]="DisplayMode == 2 ? 'top': 'auto'"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       [(ngModel)]="SelectedGuests"
                                                       #cmbGuests>


                                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                    <div *ngIf="items && items.length">
                                                        <div class="ng-value" [hidden]="DisplayMode != 2" *ngFor="let item of items | slice:0:1">
                                                            <span class="ng-value-label">{{item.FullName ? (item.FullName.length > 15 ? item.FullName.slice(0, 15) + '...' : item.FullName) : ''}}</span>
                                                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                                        </div>
                                                        <div class="ng-value" [hidden]="DisplayMode != 2" *ngIf="items.length > 1">
                                                            <span class="ng-value-label">+{{items.length - 1}}...</span>
                                                        </div>
                                                        <div class="ng-value" [hidden]="DisplayMode == 2" *ngFor="let item of items">
                                                            <span class="ng-value-label">{{item.FullName}}</span>
                                                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                                        </div>
                                                    </div>
                                                </ng-template>

                                            </ng-select>
                                        </div>
                                        <!--<div class="col-auto">
                                            <button type="button" class="btn btn-secondary" (click)="RefreshGuest()"><i class="fas fa-sync-alt"></i></button>
                                        </div>-->
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2 || Model.GlitchRegistrationType != _Glitch_RegistrationTypes.Staff">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_reporter frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstStaff"
                                                       class="req_place"
                                                       bindLabel="Name"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_STAFF' | translate}}"
                                                       name="cmbGlitchStaff"
                                                       [disabled]="Model.Operation == _GlitchOperationActions.Edit"
                                                       [(ngModel)]="Model.GlitchStaffId"
                                                       #cmbGlitchStaff>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-Location">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_location frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstLocations"
                                                       class="req_place "
                                                       bindLabel="Description"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_INCIDENT_LOCATION' | translate}}"
                                                       name="IncidentLocationId"
                                                       (change)="onLocationChange($event);"
                                                       [dropdownPosition]="DisplayMode == 2 ? 'top': 'auto'"
                                                       [(ngModel)]="Model.IncidentLocationId"
                                                       #LocationId="ngModel"
                                                       #cmbLocations>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-IncidentDt">
                                        <div class="col-1 entryIcon">
                                            <i class="fa fa-calendar scdIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <p-calendar title="{{'TITLE.TITLE_INCIDENT_TIME' | translate}}"
                                                        name="GlitchIncedentDt"
                                                        [(ngModel)]="Model.GlitchIncedentDt"
                                                        placeholder="{{'PH.PH_YYYY_MM_DD_SLASH' | translate}}"
                                                        dateFormat="yy/mm/dd"
                                                        showTime="true"
                                                        hourFormat="12"
                                                        showIcon="true"
                                                        hideOnDateTimeSelect="true"
                                                        [maxDate]="MaxDate"></p-calendar>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_category frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstCategories"
                                                       class=""
                                                       bindLabel="Description"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_CATEGORY' | translate}}"
                                                       name="CategoryId"
                                                       (change)="onCategoryChange()"
                                                       [(ngModel)]="Model.CategoryId"
                                                       #cmbCategories>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-Description">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_info frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstDescriptions"
                                                       class="req_place"
                                                       bindLabel="Description"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_DESCR' | translate}}"
                                                       [dropdownPosition]="DisplayMode == 2 ? 'top': 'auto'"
                                                       name="DescriptionsId"
                                                       [(ngModel)]="Model.DescriptionId"
                                                       (change)="DescriptionChanged($event)"
                                                       #cmbDescriptions>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell entryCell-Remarks"
                                         [hidden]="DisplayMode == 2">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_remarks frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <RemarksPopupTrigger [(Model)]="Model.Details">
                                                <textarea style="resize:none"
                                                          id="Details"
                                                          [(ngModel)]="Model.Details"
                                                          [attr.rows]="DisplayMode == 2 ? '1' : '2'"
                                                          class="form-control"
                                                          placeholder="{{'PH.PH_REMARK' | translate}}"
                                                          name="Details"></textarea>
                                            </RemarksPopupTrigger>
                                            <a [hidden]="DisplayMode == 2 || Model.Operation == _GlitchOperationActions.Edit"
                                               *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GlitchAttachment)"
                                               (click)="callAttachment.Open(Model)"
                                               class="border rounded-circle attachment"
                                               href="javascript:{}"
                                               title="{{'TITLE.TITLE_ADD_ATTACHMENTS' | translate}}">
                                                <i class="fas fa-paperclip"></i>
                                                <span *ngIf="Model.Attachments != null && Model.Attachments.length > 0">&nbsp;{{Model.Attachments.length}}</span>
                                            </a>
                                        </div>
                                        <div class="col-auto"
                                             [hidden]="DisplayMode == 2 || Model.Operation == _GlitchOperationActions.Edit">
                                            <a (click)="AddMultiple()"
                                               title="{{'TITLE.TITLE_ADD_MULTIPLE' | translate}}">
                                                <i class="fas fa-plus-circle fa-2x"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-temprament frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstGuestTemperaments"
                                                       class=""
                                                       bindLabel="Name"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_GUESTTEMPERAMENT' | translate}}"
                                                       name="GuestTemperaments"
                                                       [disabled]="Model.GlitchRegistrationType == _Glitch_RegistrationTypes.Staff"
                                                       [(ngModel)]="Model.GuestTemperamentId"
                                                       #cmbGuestTemperaments>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2">
                                        <div class="col-1 entryIcon">
                                            <i class="icon-kc-icon_staff frmIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstStaff"
                                                       class=""
                                                       bindLabel="Name"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_STAFF_INVOLVED' | translate}}"
                                                       name="GlitchStaffInvolved"
                                                       multiple="true"
                                                       [dropdownPosition]="'top'"
                                                       [(ngModel)]="Model.GlitchStaff"
                                                       #cmbGlitchStaffInvolved>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="row form-group align-items-center entryCell"
                                         [hidden]="DisplayMode == 2 || Model.Operation == _GlitchOperationActions.Edit || !CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.TagStaff_GlitchReg)">
                                        <div class="col-1 entryIcon">
                                            <i class="fas fa-tag fa-rotate-90 scdIcon"></i>
                                        </div>
                                        <div class="col entryFld">
                                            <ng-select [items]="lstStaff"
                                                       class=""
                                                       bindLabel="Name"
                                                       bindValue="Id"
                                                       placeholder="{{'PH.PH_TAGGED_STAFF' | translate}}"
                                                       name="TaggedStaff"
                                                       multiple="true"
                                                       [dropdownPosition]="'top'"
                                                       [(ngModel)]="Model.TaggedStaff"
                                                       #cmbTaggedStaff>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row form-group entryCell mr-0"
                                 [hidden]="DisplayMode != 2">
                                <div class="col-auto pointer expandToggle d-flex align-items-center"
                                     [hidden]="DisplayMode != 2"
                                     (click)="DisplayMode = 3"
                                     title="{{'TITLE.TITLE_EXPAND' | translate}}">
                                    <i class="ksv-icon-expand fa-lg"></i>
                                </div>
                            </div>

                            <div class="row form-group btnRow entryCell-btns">
                                <div class="col-1 entryIcon">&nbsp;</div>
                                <div class="col d-flex justify-content-between">
                                    <!--<div class="row justify-content-between">-->
                                    <div class="col-auto pl-0 d-flex">
                                        <button type="submit"
                                                [disabled]="IsSubmitting"
                                                class="btn btn-primary flex-fill">
                                            {{
(Model.Operation !=
                                            _GlitchOperationActions.Edit) ?
                                            ('BTN.BTN_REGISTER' | translate) :
                                            ('BTN.BTN_UPDATE' | translate)
                                            }}
                                        </button>
                                        <button type="button"
                                                [disabled]="IsSubmitting"
                                                [hidden]="Model.Operation == _GlitchOperationActions.Edit"
                                                class="btn btn-outline-primary dangerous flex-fill"
                                                (click)="onClear()"
                                                translate>
                                            BTN.BTN_CLEAR
                                        </button>
                                        <button type="button"
                                                [disabled]="IsSubmitting"
                                                [hidden]="DisplayMode != 3 || Model.Operation != _GlitchOperationActions.Edit"
                                                class="btn btn-outline-primary dangerous flex-fill"
                                                (click)="onClear(); DisplayMode=2"
                                                translate>
                                            BTN.BTN_CANCEL
                                        </button>
                                        <button type="button"
                                                [disabled]="IsSubmitting"
                                                [hidden]="DisplayMode != 3 || Model.Operation == _GlitchOperationActions.Edit"
                                                (click)="DisplayMode = 2"
                                                class="btn btn-dark"
                                                title="{{'TITLE.TITLE_COLLAPSE' | translate}}">
                                            <i class="icon-html-icons_collapse"></i>
                                        </button>
                                    </div>
                                </div>
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- DEV-20345: in split-screen the Guest Details side panel overflows
             off-screen, so (like New Job's Location history) it is shown as an
             in-view overlay dialog toggled by a button. Kept inside this
             component's view so GuestDetail binds data normally. -->
        <div
            class="locationHistoryBackdrop"
            *ngIf="showGuestDialog"
            (click)="closeGuestDialog()"
        ></div>
        <div class="ml-5 col locationHistoryInline"
             [class.locationHistoryDialog]="showGuestDialog"
             [ngClass]="DisplayMode != 2 ? 'd-flex': ''"
              [hidden]="DisplayMode == 2">
            <div class="locationHistoryDialogHeader" *ngIf="showGuestDialog">
                <span translate>LBL.GUEST_DETAILS</span>
                <button type="button" class="close" (click)="closeGuestDialog()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="floating-panel flex-fill"
                 [hidden]="!SelectedGuests.length && SaveModel.length == 0">
                <div class="colTabs">
                    <div class="tab_header"
                    *ngIf="Model.GlitchRegistrationType != _Glitch_RegistrationTypes.Visitor_Guest">
                        <ul class="nav nav-tabs">
                            <li class="nav-item"
                                *ngIf="SelectedGuests.length && Model.GlitchRegistrationType != _Glitch_RegistrationTypes.Visitor_Guest && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.FrontOffice)">
                                <a class="nav-link"
                                   [ngClass]="{'active': tabID == 2}"
                                   (click)="tabID = 2"><span translate>LBL.GUEST_DETAILS</span></a>
                            </li>
                            <li class="nav-item"
                                *ngIf="SaveModel != null && SaveModel.length > 0">
                                <a class="nav-link"
                                   [ngClass]="{'active': tabID == 3}"
                                   (click)="tabID = 3"><span translate>LBL.LBL_MULTI_GLITCHES</span></a>
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content" [hidden]="DisplayMode == 2">
                        <!-- || tabID != 2 -->
                        <GuestDetail #guest
                                     [hidden]="!SelectedGuests.length "
                                     (onGuestLoaded)="onGuestLoaded($event)"></GuestDetail>

                        <div [hidden]="SaveModel == null || SaveModel.length == 0 || tabID != 3">
                            <table class="table table-sm table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>
                                            <span translate>LBL.TYPE</span>
                                        </th>
                                        <th>
                                            <span translate>LBL.LOCATION</span>
                                        </th>
                                        <th>
                                            <span translate>LBL.DATE_TIME</span>
                                        </th>

                                        <th>
                                            <span translate>LBL.DESCR</span>
                                        </th>

                                        <th class="text-center">
                                            <span title="{{'TITLE.TITLE_ATTACHMENTS' | translate}}">
                                                <i class="fas fa-paperclip text-muted"></i>
                                            </span>
                                        </th>

                                        <th class="text-center">
                                            <span title="{{'LBL.REMARKS' | translate}}">
                                                <i class="icon-kc-icon_remarks text-muted"></i>
                                            </span>
                                        </th>

                                        <th class="text-center">
                                            <span title="{{'TITLE.TITLE_STAFF_INVOLVED' | translate}}">
                                                <i class="fas fa-user text-muted"></i>
                                            </span>
                                        </th>

                                        <th>&nbsp;</th>
                                    </tr>

                                    <tr *ngFor="let row of SaveModel; let idx = index">
                                        <td>{{idx + 1}}</td>

                                        <td>
                                            {{ row.GlitchRegistrationTypeName | translate}}
                                        </td>

                                        <td>
                                            <span>{{row.LocationName}}</span>
                                            <small *ngIf="row.FullName && row.GlitchRegistrationType != _Glitch_RegistrationTypes.Staff && row.FullName != row.LocationName">
                                                <br />{{row.FullName}}
                                            </small>
                                            <small *ngIf="row.GlitchRegistrationType == _Glitch_RegistrationTypes.Staff">
                                                <br />{{row.GlitchStaffName}}
                                            </small>
                                        </td>

                                        <td>{{row.GlitchIncedentDt | amDateFormat: DateFormat}}</td>

                                        <td>{{row.GlitchDescription}}</td>
                                        <td class="text-center">
                                            <span *ngIf="row.Attachments && row.Attachments.length > 0"
                                                  title="{{'TITLE.TITLE_ATTACHMENTS' | translate}} - {{row.Attachments.length}}">
                                                <i class="fas fa-paperclip"></i>
                                            </span>
                                        </td>

                                        <td class="linebreak">
                                            <span *ngIf="row.Details && row.Details.trim().length">
                                                <i class="icon-kc-icon_remarks" title="{{row.Details}}"></i>
                                            </span>

                                        </td>

                                        <td>
                                            <span *ngIf="row.GlitchStaff && row.GlitchStaff.length">
                                                <i class="fas fa-user" title="{{row.GlitchStaff.length}}"></i>
                                            </span>

                                        </td>

                                        <td>
                                            <button class="btn btn-link"
                                                    (click)="onGlitchDelete(row)"
                                                    title="Delete">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>

                                </thead>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #confirm let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h6 class="modal-title" translate>TITLE.TITLE_CONFIRMATION</h6>
            <button type="button"
                    class="close"
                    aria-label="Close"
                    (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body container-fluid" *ngIf="ConfirmModel">
            <div class="form-group" *ngFor="let row of ConfirmModel; last as isLast;">
                <div class="row pointer pb-2" [class.border-bottom]="!isLast" *ngIf="row && row.Result && row.Result.GlitchId && !row.IsError"
                     (click)="!row.Result.IsDuplicate && OpenWindow('/Pages/GlitchPrint?GlitchId='+row.Result.GlitchId)">
                    <div class="col-1 text-center">
                        <div *ngIf="row.Result.IsDuplicate"
                             class="statusIcon-Standard glitchstatus-dup"
                             title="{{'TITLE.TITLE_GLITCHSTATUS_DUP'  | translate}}"></div>
                        <div *ngIf="!row.Result.IsDuplicate"
                             class="statusIcon-Standard glitchstatus-{{row.Result.IsOpen}}"
                             [ngClass]="!row.Result.IsOpen ? 'border-0' : ''"
                             title="{{'TITLE.TITLE_GLITCHSTATUS_' + row.Result.IsOpen | uppercase | translate}}"></div>
                    </div>
                    <div class="col-1"
                         title="{{'TITLE.TITLE_GLITCH_NO' | translate}}">
                        {{row.Result.GlitchCallNo}}
                    </div>
                    <div class="col-3 ">
                        <div class="ellipsis"
                             title="{{('TITLE.TITLE_INCIDENT_LOCATION' | translate) + ' - ' +row.Result.LocationName}}">
                            <i class="fas fa-map-marker-alt"></i>&nbsp;{{row.Result.LocationName}}
                        </div>
                        <div *ngIf="row.Result.GuestInfo"
                             class="ellipsis text-muted "
                             title="{{('TITLE.TITLE_GUEST_NAME' | translate) + ' - '+ row.Result.GuestInfo.FullName}}">
                            <span class=""
                                  [ngClass]="{'ic-status active': row.Result.GuestInfo.Vip}">
                                <i class="fas fa-briefcase"></i>
                            </span>
                            {{row.Result.GuestInfo.FullName}}
                        </div>
                        <div *ngIf="row.Result.GlitchStaffName"
                             class="ellipsis text-muted "
                             title="{{('TITLE.TITLE_STAFF_NAME' | translate) + ' - '+ row.Result.GlitchStaffName}}">
                            {{row.Result.GlitchStaffName}}
                        </div>
                    </div>
                    <div class="col-auto pr-1 ">
                        <div class="fa-fw"
                             *ngIf="row.Result.Attachments != null && row.Result.Attachments.length >= 1"
                             title="{{row.Result.Attachments.length > 0 ? (('TITLE.TITLE_ATTACHMENTS' | translate) + ' - ' + row.Result.Attachments.length) : ('TITLE.TITLE_NO_ATTACHMENTS' | translate)}}">
                            <i class="fas fa-paperclip"></i>
                        </div>
                    </div>
                    <div class="col-3 pl-0">
                        <div class="ellipsis"
                             title="{{('TITLE.TITLE_GLITCH_DESCR' | translate) + ' - ' + row.Result.Description}}">
                            {{row.Result.Description}}
                        </div>
                        <div class="ellipsis text-muted"
                             *ngIf="row.Result.GlitchStaff && row.Result.GlitchStaff.length>0"
                             title="{{'TITLE.TITLE_STAFF_INVOLVED' | translate}}">
                            {{row.Result.GlitchStaff[0].Name}}
                            <div *ngIf="row.Result.GlitchStaff && row.Result.GlitchStaff.length > 1">
                                <span class="font-weight-bold">
                                    + {{ row.Result.GlitchStaff.length - 1}}
                                    {{'LBL.MORE' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="ellipsis text-center"
                             title="{{('TITLE.TITLE_REMARKS' | translate) + ' - ' +row.Result.Details}}"
                             *ngIf="row.Result.Details && row.Result.Details.length > 0">
                            <i class="far fa-sticky-note"></i>&nbsp;{{row.Result.Details}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" type="button" (click)="c('')" translate>
                BTN.BTN_DISMISS
            </button>
        </div>
    </ng-template>

    <ng-template #confirmGuestRemoval let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h6 class="modal-title" translate>TITLE.TITLE_RESET_GUESTS</h6>
            <button type="button"
                    class="close"
                    aria-label="Close"
                    (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body container-fluid">
            <div class="row ml-3 pb-3 pt-3">
                {{'TS.TS_CONFIRM_GUEST_RESET' | translate}}
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn" type="button" (click)="c(false)" translate>
                BTN.BTN_GO_BACK
            </button>
            <button class="btn btn-primary" type="button" (click)="c(true)" translate>
                BTN.BTN_RESET_GUESTS
            </button>
        </div>

    </ng-template>

    <CallAttachment #callAttachment
                    (AttachmentChanged)="onAttachmentChanged($event)"></CallAttachment>
    <GuestSearchPopup #guestSearchPopup
                      (SelectionChanged)="onGuestSelected($event)"></GuestSearchPopup>
    <VisitorSearchPopup #visitorSearchPopup
                      (SelectionChanged)="onVisitorSelected($event)"></VisitorSearchPopup>
    <div class="console-inline" *ngIf="DisplayMode == 1">
        <JobPopover #jobPopover
                    [Selected]="complainService._SelectedJob"
                    [Mode]="_JobPopoverMode.ReadOnly"></JobPopover>
    </div>

    <div class="console-inline" *ngIf="DisplayMode == 1">
        <GlitchPopover #glitchPopover
                       [Selected]="glitchService._SelectedGlitch"
                       [Mode]="_JobPopoverMode.ReadOnly"></GlitchPopover>
    </div>
